import { observer } from 'mobx-react';
import type React from 'react';

export interface IProps {
  avatar: string;

  id: number;
}

const ClickUserProfileAvatar: React.FC<IProps> = observer(({ avatar, id }) => {
  const formatAvatar = `/api/files/bypath/${avatar}`;
  if (!!avatar) {
    return (
      <img
        src={!id ? avatar : id && !!avatar.includes('base64,') ? avatar : formatAvatar}
        className="h-96 w-full object-cover"
      />
    );
  }
  return <div className="flex h-96 w-full items-center justify-center"></div>;
});

ClickUserProfileAvatar.displayName = 'ClickUserProfileAvatar';

export default ClickUserProfileAvatar;
